import Styles from './styles.module.css';
import React, { useMemo, useState } from 'react';
import Item from './1.item/index';
import { SchoolUserData } from 'src/type';
import { IoArrowDownOutline } from "react-icons/io5";
import UserInfo from "./userInfo/index";
import { offerCount } from '../../0.functions/offers';
import { useFitTable } from '../../0.functions/useFitTable';
import Loading from '../../9.items/loading/index';

type SchoolStudentStudentProps = {
  hashTags: string[];
  filteredUsers: any[];
  usersLoaded: boolean;
  schoolName: string;
  schoolId: string;
};

const SchoolStudentStudent: React.FC<SchoolStudentStudentProps> = ({ hashTags, filteredUsers, usersLoaded, schoolName, schoolId }) => {

  const [ type, setType ] = useState<any>({uid : "", type: ""});

  const [ sortKey, setSortKey ] = useState<SortKey>(null);

  const toggleSort = (key: SortKey) => {
    setSortKey((prev) => (prev === key ? null : key));
  };

  const getSortValue = (user: SchoolUserData, key: SortKey): number => {
    switch (key) {
      case "post":
        return user.analytics?.postCount ?? 0;
      case "pvCount":
        return user.analytics?.pvCount ?? 0;
      case "saveCount":
        return user.activity?.recruitSaves?.length ?? 0;
      case "visitCount":
        return user.activity?.recruitVisitList?.length ?? 0;
      case "志望先":
        return user.analytics?.applyStatusCount?.志望先 ?? 0;
      case "応募済み":
        return user.analytics?.applyStatusCount?.応募済み ?? 0;
      case "内定承諾":
        // 学生が登録しても学校が登録しても1人1件
        return offerCount(user, schoolId);
      case "resume":
        return user.activity?.resume ? 1 : 0;
      default:
        return 0;
    }
  };

  const displayList = useMemo(() => {
    if (!sortKey) return filteredUsers;

    return [...filteredUsers].sort(
      (a, b) => getSortValue(b, sortKey) - getSortValue(a, sortKey)
    );
  }, [filteredUsers, sortKey]);

  // 表は画面の高さに合わせ、見出しを残して行だけをスクロールする
  const tableRef = useFitTable<HTMLDivElement>();

  return (
    <>
    <div className={Styles.table} ref={tableRef}>

      <div className={Styles.table_nav}>
        
        <h3 className={Styles.name}>名前</h3>

        <div style={{ flex: "1", alignItems: "center" }}></div>

        <h3 className={Styles.items} onClick={() => toggleSort("post")}>
          作品数<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "post" ? "var(--mw-brand)" : undefined }} />
        </h3>

        <h3 className={Styles.items} onClick={() => toggleSort("pvCount")}>
          閲覧数<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "pvCount" ? "var(--mw-brand)" : undefined }} />
        </h3>

        <h3 className={Styles.items} onClick={() => toggleSort("saveCount")}>
          保存数<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "saveCount" ? "var(--mw-brand)" : undefined }} />
        </h3>

        <h3 className={Styles.items} onClick={() => toggleSort("visitCount")}>
          見学数<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "visitCount" ? "var(--mw-brand)" : undefined }} />
        </h3>

        <h3 className={Styles.items} onClick={() => toggleSort("志望先")}>
          志望先数<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "志望先" ? "var(--mw-brand)" : undefined }} />
        </h3>
        
        <h3 className={Styles.items} onClick={() => toggleSort("応募済み")}>
          応募中<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "応募済み" ? "var(--mw-brand)" : undefined }} />
        </h3>
        
        <h3 className={Styles.items} onClick={() => toggleSort("内定承諾")}>
          内定承諾<IoArrowDownOutline className={Styles.order_icon} style={{ color: sortKey === "内定承諾" ? "var(--mw-brand)" : undefined }} />
        </h3>
        
        <div style={{ flex: "1", alignItems: "center" }}></div>
        
        <h3 className={Styles.items}>履歴書</h3>
        <h4 className={Styles.items}>レポート</h4>

      </div>

      <div className="schoolTableBody">
        {hashTags.length <= 2 ? (
         <p className={Styles.recruit_none}>コース、学年、クラスを選択してください。</p>
        ) : !usersLoaded ? (
          <Loading />
        ) : displayList.length === 0 ? (
          <p className={Styles.recruit_none}>該当する学生がいらっしゃいません。</p>
        ) : (
          displayList.map((data, index) => (
            <Item data={data} key={index} setType={setType} schoolId={schoolId} />
          ))
        )}
      </div>

    </div>

    {type.uid !== "" && (
      <UserInfo type={type} setType={setType} schoolName={schoolName} schoolId={schoolId}
        user={filteredUsers.find((u) => (u.uid ?? u.id) === type.uid)} />
    )}
    </>
  );
}

export default SchoolStudentStudent;

export type SortKey =
  | "post"
  | "pvCount"
  | "saveCount"
  | "visitCount"
  | "志望先"
  | "応募済み"
  | "内定承諾"
  | "resume"
  | null;